import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { LoadingController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-tab3',
  templateUrl: 'tab3.page.html',
  styleUrls: ['tab3.page.scss']
})
export class Tab3Page {
  loading:any
  contents:any = [];
  selected_language = "en";
  constructor( private _translate: TranslateService,private sanitizer: DomSanitizer,private http: HttpClient,private loadingCtrl: LoadingController) {}
  ionViewWillEnter(){
    this.presentLoading(this.getTranslation("general.wait"));
    this.http.get("https://api.infoparkingamalfi.com/info").subscribe(async res=>{
      await this.hideLoading();
      this.contents = res
      console.log(this.contents)
    })
  }

  ionViewDidEnter()
  {
    this.selected_language = localStorage.getItem("language_select");
  }

  async presentLoading(message = "Please Wait...") {
    this.loading = await this.loadingCtrl.create({
      spinner: 'lines-small',
      message: message,
      translucent: true,
      cssClass: 'custom-class custom-loading'
    });
    await this.loading.present();
  }

  async hideLoading() {
    await this.loading.dismiss();
  }

  contentSanitize(html)
  {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
  getTranslation(key)
  {
    return this._translate.instant(key)
  }

}
